import { Formik, Form, Field, FieldArray } from "formik"


const ProfileDataForm = ({ profile, saveProfile, setEditMode }) => {

    return <>
        <Formik
            initialValues={profile}
            onSubmit={(values, { setSubmitting, setStatus }) => {
                saveProfile(values, setSubmitting, setStatus).then(() => {
                    setEditMode(false)
                }).catch(() => {

                })
            }}>

            {({
                values,
                handleSubmit,
                isSubmitting,
                status
            }) => (
                <Form onSubmit={handleSubmit}>
                    <div>
                        <button type="submit" disabled={isSubmitting}>
                            Save
                        </button>
                        {status && <div>{status}</div>}
                    </div>
                    <div>
                        <b>FullName</b>:
                        <Field type="fullName" name="fullName" placeholder="" />
                    </div>
                    <div>
                        <b>Looking for a job</b>:
                        <Field type="checkbox" name="lookingForAJob" placeholder="" />
                    </div>
                    {values.lookingForAJob &&
                        <div>
                            <b>My professional skills</b>: <Field type="text" name="lookingForAJobDescription" placeholder="" />
                        </div>
                    }
                    <div>
                        <b>About me</b>: <Field type="text" name="aboutMe" placeholder="" />
                    </div>
                    <div>
                        <b>Contacts</b>:
                        <FieldArray>
                            {
                                (fieldArrayProps) => {

                                    const { form } = fieldArrayProps
                                    const { values } = form
                                    const { contacts } = values

                                    return <div>
                                        {
                                            Object.keys(contacts).map((key, index) => {
                                                return (
                                                    <div key={index}>
                                                        <b>{key}</b>  : <Field type="text" name={`contacts.${key}`} placeholder="" />
                                                        {/* {status && <div>{status}</div>} */}
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                }
                            }
                        </FieldArray>
                    </div>
                </Form>
            )}
        </Formik>
    </>
}

export default ProfileDataForm